/**
 * Utility functions for slot operations
 */
import { slotInstantMs } from './timezone';

/**
 * Check if a slot is in the past based on its date and end time.
 * A slot is considered past if its end time (resolved through the activity
 * timezone) has already occurred. `date`/`endTime` are the stored Europe/Paris
 * wall-clock; comparing the resolved absolute instant against now is timezone-
 * safe regardless of the viewer's browser.
 *
 * @param slot - Object containing date (YYYY-MM-DD) and endTime (minutes since midnight)
 * @returns true if the slot's end time is in the past
 */
export const isSlotInPast = (slot: { date: string; endTime: number }): boolean => {
  return slotInstantMs(slot.date, slot.endTime) < Date.now();
};
